import { alphaDuneTestnetContracts } from "./contracts.inventory";

export const alphaDuneTestnetCurrencies = [
  { label: 'DUNE', value: '0x3567f7a48353A7C4001Ebe9e129f2163b891F4FA' },
  { label: 'HPO', value: alphaDuneTestnetContracts.HOUNDRACE_POTIONS }
];

export function currencies(chain_id: number) {
  switch(Math.abs(chain_id)) {
    case 4126084:
      return alphaDuneTestnetCurrencies;
    default:
      return alphaDuneTestnetCurrencies;
  }
}

export function getCurrencyLabel(chainId: number, currencyAddress: string): string {
  const chainCurrencies = currencies(chainId);
  for ( let i = 0 , l = chainCurrencies.length ; i < l ; ++i ) {
    if ( chainCurrencies[i].value === currencyAddress ) {
      return chainCurrencies[i].label;
    }
  }
  return "UNKNOWN";
}
